import { combineEpics } from 'redux-observable';
import { errorHandlingEpic } from '@/core/features/errorHandling/state/epics';
import { loaderEpic } from '@/core/features/loader/state/epics';
import { appEpic } from '@/slices/app/epics';
import { userEpic } from '@/slices/user/epics';
import { dashboardEpic } from '@/slices/dashboard/epics';
import { eventsEpic } from '@/slices/events/epics';
import { membersEpic } from '@/slices/members/epics';

export default combineEpics(
  errorHandlingEpic,
  loaderEpic,
  appEpic,
  userEpic,
  dashboardEpic,
  eventsEpic,
  membersEpic,
);
